@use "../../../../../../../../../sedestral/sass/mixins/texts";

.componentIndexationRecharge {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px;

  .explain {
    font-size: 13px;
    color: var(--grey-text-very-dark);
    line-height: 1.5;
  }

  .packs {
    display: flex;
    gap: 12px;
    padding-top: 10px;

    .packCard {
      flex: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      padding: 18px 12px;
      background: var(--white);
      border: 2px solid var(--grey-sur);
      border-radius: 14px;
      cursor: pointer;
      transition: border-color 0.15s, box-shadow 0.15s;

      &:hover {
        border-color: var(--grey-sur-hover);
      }

      &.popularCard {
        box-shadow: 0 6px 18px var(--grey-sur);

        .popular {
          position: absolute;
          top: -11px;
          left: 50%;
          transform: translateX(-50%);
          padding: 3px 12px;
          background: var(--black);
          color: var(--white);
          border-radius: 25px;
          font-size: 11px;
          white-space: nowrap;

          @include texts.font("semi-bold");
        }
      }

      &.selected {
        border-color: var(--black);

        .packSelect {
          border-color: var(--black);

          &::after {
            opacity: 1;
          }
        }
      }

      .packSelect {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 16px;
        height: 16px;
        border: 2px solid var(--grey-sur);
        border-radius: 50%;

        &::after {
          content: '';
          position: absolute;
          inset: 2px;
          background: var(--black);
          border-radius: 50%;
          opacity: 0;
          transition: opacity 0.15s;
        }
      }

      .packCredits {
        font-size: 18px;
        color: var(--black);

        @include texts.font("bold");
      }

      .packPrice {
        font-size: 14px;
        color: var(--grey-text-very-dark);

        @include texts.font("semi-bold");
      }
    }
  }

  .freeRow {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background: var(--grey-sur-opac);
    border-radius: 12px;

    .freeLabel {
      font-size: 13px;
      color: var(--black);
      white-space: nowrap;

      @include texts.font("semi-bold");
    }

    .freeInputHost {
      flex: 1;
      min-width: 0;
      height: 40px;

      input {
        width: 100%;
        height: 100%;
      }
    }

    .freePrice {
      font-size: 14px;
      color: var(--black);
      min-width: 60px;
      text-align: right;

      @include texts.font("bold");
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
    border-top: 1px solid var(--grey-sur);
  }
}
